import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Lightbulb as QuickRecapIcon } from '@mui/icons-material';

interface QuickRecapBadgeProps {
  hasCourse: boolean;
  hasVideo: boolean;
  onClick: () => void;
  size?: 'small' | 'medium' | 'large';
}

const QuickRecapBadge: React.FC<QuickRecapBadgeProps> = ({
  hasCourse,
  hasVideo,
  onClick,
  size = 'medium',
}) => {
  const iconSize = size === 'small' ? 18 : size === 'medium' ? 22 : 28;
  const badgeSize = size === 'small' ? 8 : size === 'medium' ? 10 : 12;
  const buttonSize = size === 'small' ? 'small' : 'medium';

  return (
    <Tooltip title="Gérer les Quick Recaps">
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        size={buttonSize}
        sx={{
          position: 'relative',
          '&:hover': {
            bgcolor: 'action.hover',
          },
        }}
      >
        <QuickRecapIcon sx={{ fontSize: iconSize, color: 'primary.main' }} />

        {/* PDF/Course Badge - Top Right */}
        <Box
          sx={{
            position: 'absolute',
            top: size === 'small' ? 4 : 6,
            right: size === 'small' ? 4 : 6,
            width: badgeSize,
            height: badgeSize,
            borderRadius: '50%',
            bgcolor: hasCourse ? 'success.main' : 'error.main',
            border: '1.5px solid white',
            boxShadow: 1,
          }}
        />

        {/* Video Badge - Bottom Right */}
        <Box
          sx={{
            position: 'absolute',
            bottom: size === 'small' ? 4 : 6,
            right: size === 'small' ? 4 : 6,
            width: badgeSize,
            height: badgeSize,
            borderRadius: '50%',
            bgcolor: hasVideo ? 'success.main' : 'error.main',
            border: '1.5px solid white',
            boxShadow: 1,
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default QuickRecapBadge;
